import { createSlice } from '@reduxjs/toolkit';

const isNewDraft = window.location.pathname?.endsWith('new');
const queryParams = new URLSearchParams(window.location.search);
const queryParamCharityId = queryParams.get('charityId');
const preselectCharity = isNewDraft && queryParamCharityId;

const initialStateShipping = {
    forceFreeShipping: false,
    isFreeShippingPaidByProvider: false,
    freeShippingPaidByProviderName: null
};

const initialState = {
    anonymous: true,
    charityId: preselectCharity ? Number(queryParamCharityId) : null,
    description: null,
    logoUrl: null,
    name: null,
    percentageToDonate: preselectCharity ? 100 : 0,
    ...initialStateShipping
};

const charitySlice = createSlice({
    name: 'charity',
    initialState,
    reducers: {
        setCharityId: (state, { payload }) => {
            state.charityId = payload.charityId;
            if (payload.charityId) {
                state.percentageToDonate = 100;
            } else {
                state.percentageToDonate = 0;
            }
        },
        setCharityInfo: (
            state,
            { payload: { name, description, logoUrl } }
        ) => {
            return { ...state, name, description, logoUrl };
        },
        setCharityAnonymous: (state, { payload }) => {
            state.anonymous = payload.anonymous;
        },
        setCharityFromDraft: (state, { payload }) => {
            state.charityId = payload.charityId;
            state.percentageToDonate = payload.percentageToDonate;
            state.anonymous = payload.anonymous;
        },
        resetCharity: () => {
            return { ...initialState };
        },
        setCharityShippingInfo: (state, { payload }) => {
            return { ...state, ...payload };
        }
    }
});

export const {
    resetCharity,
    setCharityAnonymous,
    setCharityFromDraft,
    setCharityId,
    setCharityInfo,
    setCharityShippingInfo
} = charitySlice.actions;

export default charitySlice.reducer;
